<template>
  <div>
    <ok-modal
      :value="value"
      size="md"
      :title="$t('users.add-new-account')"
      @change="close()"
    >
      <validation-observer
        ref="loginForm"
        #default="{invalid}"
      >
        <b-form
          class="auth-login-form mt-2"
          @submit.prevent="submit"
        >
          <ok-text-input
            v-model="email"
            dir="ltr"
            input-class="text-left"
            :label="$t('fields.email')"
            :is-required="true"
            hide-required-asterisk
          />
          <!-- password -->
          <b-form-group>
            <div class="d-flex justify-content-between">
              <label class="auth-label">{{ $t('fields.password') }}</label>
              <b-link
                :to="{name:'auth:forget'}"
                :target="'_blank'"
              >
                <small>{{ $t('auth.forgot-pass') }}</small>
              </b-link>
            </div>
            <validation-provider
              #default="{ errors }"
              name="Password"
              rules="required"
            >
              <password-input
                v-model="password"
                :label="$t('fields.password')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- checkbox -->

          <!-- submit button -->
          <b-button
            variant="primary"
            type="submit"
            block
            class="mt-2"
            :disabled="invalid || submitting"
          >
            {{ $t('auth.signin') }}
            <b-spinner
              v-if="submitting"
              small
              class="mr-50"
            />
          </b-button>
        </b-form>
      </validation-observer>
    </ok-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BButton, BForm, BFormGroup, BLink, BSpinner,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import OkModal from '@/@okmenu/components/modals/OkModal'
import OkTextInput from '@/@okmenu/components/inputs/OkTextInput'
import PasswordInput from '@/@okmenu/components/inputs/PasswordInput'
import StorageService from '@/services/storage-service'

export default {
  name: 'AddNewAccountPopup',

  components: {
    OkModal, ValidationObserver, ValidationProvider, OkTextInput, PasswordInput, BButton, BLink, BFormGroup, BForm, BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    defaultEmail: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      submitting: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  watch: {
    defaultEmail(value) {
      console.log('watch default email: ', value)
      this.email = value
    },
  },

  mounted() {
    // this.email= this.defaultEmail
  },
  methods: {
    close() {
      this.email = null
      this.password = null
      this.$emit('close')
    },
    submit() {
      this.submitting = true
      this.$store.dispatch('auth/SWITCH_ACCOUNT', { email: this.email, password: this.password, main_account: this.user.email })
        .then(res => {
          console.log(res.user)
          const { user } = res
          this.submitting = false
          this.close()
          this.$notifySuccess(this.$t('auth.welcome-back-user', [user.name]))
          const pendingRoute = StorageService.getItem('okmenu_route_after_auth', null, -1)
          this.$router.push(pendingRoute ?? { name: 'admin:home' }).catch(() => {})
        })
        .catch(err => {
          this.$notifyError(err)
          this.error = err
          this.submitting = false
        })
    },
  },

}
</script>
